import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TouchIdComponent } from './component/touch-id/touch-id.component';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { UtilComponentsModule } from 'src/app/shared/util-components/util-components.module';


@NgModule({
  declarations: [
    TouchIdComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    UtilComponentsModule
  ],
  exports:[TouchIdComponent]
})
export class TouchidModule { }
